<template>
  <el-dialog
    :title="name"
    :visible.sync="dialogVisible"
    width="80%"
    :before-close="handleClose"
    top="5vh"
  >
    <el-form ref="from" :model="adminDepartment" label-width="100px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="操作员姓名">
            {{ name }}
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-form-item label="部门权限">
          <div style="width: 100%; max-height: 200px; overflow-y: scroll">
            <el-tag
              v-for="(item, key) in adminDepartment.departmentNames"
              :key="key"
              style="display: block;"
            >
              {{ item }}
            </el-tag>
          </div>
        </el-form-item>
      </el-row>

      <el-row>
        <el-tabs v-model="activeName" type="card">
          <el-tab-pane label="树状图" name="tree">
            <el-form-item label="可选部门">
              <div style="width: 100%; height: 400px; overflow-y: scroll">
                <el-tree
                  ref="tree"
                  :props="defaultProps"
                  :lazy="true"
                  :load="getTreeData"
                  node-key="id"
                  show-checkbox
                  :default-checked-keys="adminDepartment.departmentIds"
                />
              </div>
            </el-form-item>
          </el-tab-pane>
          <el-tab-pane label="穿梭框" name="transfer">
            <el-row :gutter="8">
              <el-col :span="20">
                <el-form-item label="可选部门">
                  <el-input v-model="keyword" placeholder="输入关键词搜索" />
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-button
                  type="primary"
                  icon="el-icon-search"
                  @click="getData()"
                />
              </el-col>
            </el-row>
            <el-form-item>
              <div
                class="edit_dev edit_dev_body edit_dev_checkbox edit_dev_input"
              >
                <el-transfer
                  v-model="departmentIds"
                  :data="data"
                  filterable
                  filter-placeholder="请输入具体关键词"
                />
              </div>
            </el-form-item>
          </el-tab-pane>
        </el-tabs>
      </el-row>
      <el-form-item>
        <div>
          <el-button type="primary" plain @click="save(1)">添加</el-button>
          <el-button type="primary" plain @click="save(2)">替换</el-button>
          <el-button plain @click="handleClose">取消</el-button>
        </div>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>
  
  <script>
import Http from "@/components/Admin/Flow/common/Http";
export default {
  name: "OperatorDepartmentSelect",
  props: {
    mode: {
      type: String,
      default: "view",
    },
    id: {
      type: Number | String,
      default: null,
    },
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      pindexList: [],
      defaultProps: {
        // label: 'name',
        children: "",
        label: "name",
      },
      adminDepartment: {
        departmentIds: [],
        departmentNames: [],
      },
      defaultcheckedkeys: [],
      count: 1,
      node: [],
      resolve: [],
      keyword: "",
      data: [],
      departmentIds: [],
      activeName: "tree",
    };
  },
  mounted() {
    this.getAdminDepartment();
  },
  watch: {
    id(n, o) {
      if (this.count == 1) {
        this.count = 2;
      } else {
        this.$refs.tree.setCheckedKeys([]);
      }
      this.getAdminDepartment();
    },
  },
  methods: {
    getData() {
      Http.post(
        "hr/Department/searchDepartment",
        { keyword: this.keyword },
        (res) => {
          var list = res.data;
          this.data = list.map((item) => {
            return {
              key: item.id,
              label: item.ancestor_name,
              disabled: false,
            };
          });
        }
      );
    },
    getTreeData(node, resolve) {
      setTimeout(() => {
        var parent_id = 0;
				console.log(node.data)
        if (node.data != undefined) {
          console.log(node);
          parent_id = node.data.id;
        }
        //加载
        Http.get("hrm/department/list", { parent_id }, (res) => {
          var listData;
          listData = res.data.map((item) => {
            return {
              name: item.department_name,
              id: item.id,
            };
          });
          return resolve(listData);
        });
      }, 300);
    },
    getAdminDepartment() {
      if (this.id == null || this.id == 0) {
        return;
      }
      Http.post("hr/User/getUserDepartmentList", { id: this.id }, (res) => {
        this.adminDepartment = res.data;
      });
    },
    handleClose() {
      this.departmentIds = [];
      this.$emit("close", false);
    },
    save(type) {
      if (this.id == null || this.id == 0) {
        return;
      }
      if(this.activeName === 'tree') {
        let checkedKeys = this.$refs.tree.getCheckedKeys(); //获得全选状态id
        this.departmentIds = checkedKeys;
      }
      Http.post(
        "hr/User/editUserDepartmentRight",
        { id: this.id, departmentIds: this.departmentIds, type, activeName: this.activeName },
        (res) => {
          if (res.code == 0) {
            this.$message.success(res.msg);
            this.getAdminDepartment();
          } else {
            this.$message.error(res.msg);
          }
        }
      );
    },
    choiceAll() {
      const keys = this.pindexList.map((item) => {
        return item.id;
      });
      this.$refs.tree.setCheckedKeys(keys);
    },
    cancelAll() {
      this.$refs.tree.setCheckedKeys([]);
    },
  },
};
</script>
  
<style scoped>
.edit_dev >>> .el-transfer-panel {
  width: 500px;
}
.edit_dev_body >>> .el-transfer-panel__item {
  display: block !important;
  overflow: auto;

}
.edit_dev_checkbox >>> .el-checkbox__label {
  font-size: 12px !important;
  line-height: 15px !important;
}
.edit_dev_input >>> .el-checkbox__input {
  top: 0px;
}
</style>
  


// WEBPACK FOOTER //
// src/components/Admin/Config/Operator/OperatorDepartmentSelect.vue